/**
 * Build a Strapi-style query prefix (?a=1&b=2) with RFC 3986 encoding for keys and values.
 * Values are coerced with String() to match previous template-literal behavior (including null/undefined).
 */
function buildEncodedCustomQueryString(params) {
  if (params == null || typeof params !== 'object') return ''
  const pairs = []
  for (const key in params) {
    pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`)
  }
  if (pairs.length === 0) return ''
  return `?${pairs.join('&')}`
}

export const useStrapiAsyncData = () => {
  const find = async (type, transform) => {
    return await useFetch('/api/strapi-rest', {
      method: 'GET',
      query: { mode: 'find', suffix: type },
      transform,
    })
  }

  const findOne = async (type, params, transform) => {
    const query = {
      mode: 'findOne',
      entity: type,
      id: params.id,
    }
    if (params.populate) {
      query.populate = params.populate
    }
    return await useFetch('/api/strapi-rest', {
      method: 'GET',
      query,
      transform,
    })
  }

  const findOneBySlug = async (_type, params, transform) => {
    return await useFetch('/api/find-one-by-slug', {
      method: 'GET',
      query: {
        slug: params.slug,
        entity: params.entity,
      },
      transform,
    })
  }

  const customService = async (type, service, params, transform, _method = 'GET') => {
    const qs = buildEncodedCustomQueryString(params)
    return await useFetch('/api/strapi-rest', {
      method: 'GET',
      query: { mode: 'custom', type, service, qs },
      transform,
    })
  }

  return {
    find,
    findOne,
    findOneBySlug,
    customService,
  }
}
